module.exports = __webpack_public_path__ + "img/phone.fe26658f.png";